import { ElementProps } from '@/components/sections/builder/types';

import { FooterSectionType } from '@/components/sections/builder/elements/footer/footer/types';

import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import InputTab from '@/components/sections/builder/settings/input-tab';
import { getInnerText } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import { Type } from 'lucide-react';
import { shallow } from 'zustand/shallow';

const defaultData: FooterSectionType = {
  name: 'Text',
  heading: 'Text',
  subtext: '<p>Text</p>',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as FooterSectionType;

  return (
    <>
      <div
        className={clsx(
          'flex h-full w-full flex-col',
          data.contentTextAlign === 'left' && '[&>*]:text-left',
          data.contentTextAlign === 'center' && '[&>*]:text-center',
          data.contentTextAlign === 'right' && '[&>*]:text-right',
          data.contentTextPosition === 'top' && 'justify-start',
          data.contentTextPosition === 'middle' && 'justify-center',
          data.contentTextPosition === 'bottom' && 'justify-end'
        )}
      >
        <h2
          className='mb-1 text-lg font-medium '
          dangerouslySetInnerHTML={{ __html: data.heading || '' }}
        ></h2>
        <p
          className='content-footer-text'
          dangerouslySetInnerHTML={{ __html: data.subtext || '' }}
        ></p>
      </div>
    </>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as FooterSectionType;

  return (
    <div>
      <div className='mb-3'>
        <h3 className='mb-2'>Heading</h3>
        <TextEditorMinimal
          value={data.heading as string}
          onChange={(val) => {
            builder.setChildData(element.parentId as string, element.id, {
              name: getInnerText(val as string),
              heading: val,
            });
          }}
          output='html'
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
            },
          }}
          editable
        />
      </div>
      <div>
        <h3 className='mb-2'>Subtext</h3>
        <TextEditorMinimal
          value={data.subtext as string}
          onChange={(val) => {
            builder.setChildData(element.parentId as string, element.id, {
              subtext: val,
            });
          }}
          output='html'
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
            },
          }}
          editable
        />
      </div>
      <div className='mb-4 mt-4 font-bold'>Text Alignment</div>
      <InputTab
        defaultValue={data.contentTextAlign}
        options={[
          { label: 'Left', value: 'left' },
          { label: 'Center', value: 'center' },
          { label: 'Right', value: 'right' },
        ]}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, {
            contentTextAlign: val,
          });
        }}
      />
      <div className='mb-4 mt-4 font-bold'>Text Position</div>
      <InputTab
        defaultValue={data.contentTextPosition}
        options={[
          { label: 'top', value: 'top' },
          { label: 'middle', value: 'middle' },
          { label: 'bottom', value: 'bottom' },
        ]}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, {
            contentTextPosition: val,
          });
        }}
      />
    </div>
  );
}

const FooterSectiorText = {
  type: 'footer_section_text',
  group: 'footer_section',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default FooterSectiorText;
